import React, { PureComponent } from 'react';

import {
    TouchableOpacity,
    StyleSheet
} from 'react-native';

import {
    JDImage,
    JDNativeSystem
} from '@jdreact/jdreact-core-lib';

import img from '../../common/img';
import { pt } from '../../common/utils';

class ScrollTopButton extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <TouchableOpacity
                style={[st.button_wrap, {bottom: pt(30) + iphoneXMarginBottom}]}
                activeOpacity={0.5}
                onPress={this.props.goTop}
            >
                <JDImage style={st.img} source={img.to_top}></JDImage>
            </TouchableOpacity>
        )
    }
}

const st = StyleSheet.create({
    button_wrap: {
        position: 'absolute',
        right: 0
    },
    img: {
        width: pt(50),
        height: pt(50)
    }
})

export default ScrollTopButton;